module.exports = __webpack_public_path__ + "img/enlogo.aa8c1efd.png";